import { Helmet } from 'react-helmet-async';
import { useSEO } from '@/hooks/useSEO';

export default function SEO() {
  const { seoData, loading } = useSEO();

  if (loading) return null;

  return (
    <Helmet>
      <title>{seoData.title}</title>
      <meta name="description" content={seoData.description} />
      <meta name="keywords" content={seoData.keywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={seoData.title} />
      <meta property="og:description" content={seoData.description} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={seoData.title} />
      <meta name="twitter:description" content={seoData.description} />
    </Helmet>
  );
}
